const Constants = {
    DefaultFontFamily: 'DinPro',
    PageSizeOptions: [5, 10, 15],
    DefaultPageSize: 10,
};

export default Constants;